<!-- content projection supports cs-badge and other inline elements (rendered in dropdown row) -->
<ng-template #contentTemplate>
  <ng-content></ng-content>
</ng-template>
